module.exports = __webpack_public_path__ + "static/img/b5-3.ddb947b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b5-3.png
// module id = 1XOO
// module chunks = 1